module.exports = __webpack_public_path__ + "8478899dbdd9df43b3dc5ee3f638c63e.svg";